import React from "react";
import { LineChart, lineElementClasses } from "@mui/x-charts/LineChart";
import { useMediaQuery } from "@mui/material";

const Day2CompanyWise = () => {
  const labels = [
    "Reliance Ind",
    "Myntra",
    "Amadeus Labs",
    "Micron",
    "CashFree",
    "Quicksell",
    "Dezerv",
    "IDFC",
    "ICICI",
    "Sandvine",
    "Amdocs",
    "Orica",
    "Catterpillar",
    "Merilytics",
    "Paytm",
    "Chevron"
  ];

  const data = [14, 3, 5, 2, 2, 2, 1, 3, 16, 2, 16, 2, 3, 8, 19, 8];
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const chartWidth = isSmallScreen ? 300 : isMediumScreen ? 600 : 1500;
  const chartHeight = isSmallScreen ? 200 : 600;
  
  return (
    <div>
      <h2
        style={{
          fontSize: "clamp(1.5rem, 2vw, 2.5rem)",
          marginBottom: "1rem",
          color: "rgba(238, 79, 152, 1)",
        }}
      >
        Day 2 - Company-Wise
      </h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LineChart
          width={chartWidth}
          height={chartHeight}
          series={[
            {
              curve: "linear",
              data: data,
              label: "No of Students Selected",
              color: "rgba(238, 89, 152, 1)",
            },
          ]}
          xAxis={[{ scaleType: "point", data: labels }]}
          grid={{ vertical: true, horizontal: true }}
          margin={{
            right: 70,
            left: 30,
          }}
        />
      </div>
    </div>
  );
};

export default Day2CompanyWise;
